import TabMenu from "./tabmenu";
import extractOptions from "../../utility/extractOptions";

export function applyToElements() {

    const tabmenuElements = document.querySelectorAll("[data-tabmenu]");
    console.log(tabmenuElements);
    const tabmenuElementsArray = Array.prototype.slice.call(tabmenuElements);

    tabmenuElementsArray.forEach(applyToElement);

}

export function applyToElement(element) {

        const options = Object.assign(
            {},
            TabMenu.DEFAULTS,
            extractOptions("tabmenu", element)
        );
        const instance = new TabMenu(element, options);
        
        element.instance = instance;
}


export function focusOnTab(element) {

    element.instance.focusOnTab();

}


// WEBPACK FOOTER //
// ./project/client/src/core/components/tabmenu/index.js